import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCustomers } from "../../components/Chat/fetchingData/fetchCustomers";
import { fetchSellers } from "../../components/Chat/fetchingData/fetchSellers";


export const getCustomersData = createAsyncThunk(
    'GET_CUSTOMERS_DATA',
    async () => {
        return await fetchCustomers()
    }
);

export const getSellersData = createAsyncThunk(
    'GET_SELLERS_DATA',
    async () => {
        return await fetchSellers()
    }
);